var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.250015H0V4.75002H1.125V10V17.5V18.625H2.25H6V19.75H10.5V15.25H6V16.375H3.375V11.125H6V12.25H10.5V7.75002H6V8.87502H3.375V4.75002H4.5V0.250015ZM7.5 1.00002V4.00002H9H22.5H24V1.00002H22.5H9H7.5ZM13.5 8.50002V11.5H15H22.5H24V8.50002H22.5H15H13.5ZM13.5 16V19H15H22.5H24V16H22.5H15H13.5Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTool);
export default __webpack_public_path__ + "static/media/category_tool.ce33c111bdd939301c6d3257009759e4.svg";
export { ForwardRef as ReactComponent };